{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/MNA",
	"name": "MNA",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "MNA schaal",
	"purpose": "Evalueert het risico op ondervoeding",
	"description": "De afname verloopt in twee delen. Eerst registreren we de screening waar scores van meer dan 11 (max. 14) een aanvaardbare voedingsstatus weergeven. Patiënten die geclassificeerd worden met “risico op ondervoeding” (score onder 12) dienen de volledige vragenlijst te vervolledigen. Een score lager dan 17 punten staat gelijk aan malnutritie. Een score tussen 17-23,5 geeft een risico aan op ondervoeding . Een score hoger of gelijk aan 24 geeft aan dat de persoon in een goede voedingstoestand verkeert.",
	"item": [
		{
			"linkId": "50100",
			"text": "Controle",
			"type": "group",
			"item": [
				{
					"linkId": "50200",
					"text": "Bent u de afgelopen 3 maanden minder gaan eten als gevolg van verminderde eetlust, spijsverteringsproblemen, problemen bij het kauwen of slikken?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50201",
								"display": "Beduidende afname eetlust"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50202",
								"display": "Matig verlies van eetlust"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50203",
								"display": "Geen verlies van eetlust"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50300",
					"text": "Gewichtsafname gedurende de afgelopen maanden",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50301",
								"display": "Gewichtsafname groter dan 3 kg"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50302",
								"display": "Weet niet"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50303",
								"display": "Gewichtsafname tussen 1 en 3 kg"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "50304",
								"display": "Geen gewichtsafname"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50400",
					"text": "Mobiliteit",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50401",
								"display": "Aan bed of stoel gebonden"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50402",
								"display": "In staat zelfstandig uit bed/stoel te komen, maar gaat niet naar buiten"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50403",
								"display": "Gaat zelfstandig naar buiten"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50500",
					"text": "Heeft u gedurende de afgelopen 3 maanden last gehad van mentale spanning (stress) of acute ziekteverschijnselen?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50501",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50502",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50600",
					"text": "Neuropsychologische problemen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50601",
								"display": "Ernstig dement of depressief"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50602",
								"display": "Licht dement of depressief"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50603",
								"display": "Geen psychologische problemen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50700",
					"text": "Lichaamsmassa index (BMI)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50701",
								"display": "BMI minder dan 19"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50702",
								"display": "BMI tussen 19 en 21"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50703",
								"display": "BMI tussen 21 en 23"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "50704",
								"display": "BMI 23 of meer"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "mna-screening-instructions",
					"text": "Score 12 of meer: Normaal. Geen risico, geen noodzaak om het formulier verder in te vullen. | Score 11 of minder: Verhoogde kans op ondervoeding, vul het formulier verder in wanneer het verschijnt.",
					"type": "display",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "<strong>Score 12 of meer</strong>: Normaal. Geen risico, geen noodzaak om het formulier verder in te vullen.<br/><strong>Score 11 of minder</strong>: Verhoogde kans op ondervoeding, vul het formulier verder in wanneer het verschijnt."
							}
						]
					}
				}
			]
		},
		{
			"linkId": "50800",
			"text": "Onderzoek",
			"type": "group",
			"extension": [
				{
					"url": "http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-enableWhenExpression",
					"valueExpression": {
						"language": "text/fhirpath",
						"expression": "%resource.item.where(linkId='50100').item.where(linkId='50200').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50300').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50400').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50500').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50600').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50700').answer.exists() and (iif(%resource.item.where(linkId='50100').item.where(linkId='50200').answer.valueCoding.code='50202',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50200').answer.valueCoding.code='50203',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50300').answer.valueCoding.code='50302',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50300').answer.valueCoding.code='50303',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50300').answer.valueCoding.code='50304',3,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50400').answer.valueCoding.code='50402',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50400').answer.valueCoding.code='50403',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50500').answer.valueCoding.code='50502',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50600').answer.valueCoding.code='50602',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50600').answer.valueCoding.code='50603',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50700').answer.valueCoding.code='50702',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50700').answer.valueCoding.code='50703',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50700').answer.valueCoding.code='50704',3,0)) <= 11"
					}
				}
			],
			"item": [
				{
					"linkId": "50900",
					"text": "Woont onafhankelijk (d.w.z. niet in een verpleeghuis of ziekenhuis)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50902",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50901",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51000",
					"text": "Neemt dagelijks meer dan 3 voorgeschreven medicijnen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51001",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51002",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51100",
					"text": "Decubitus of huidontstekingen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51101",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51102",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51200",
					"text": "Aantal volledige maaltijden genuttigd per dag",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51201",
								"display": "1 maaltijd"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51202",
								"display": "2 maaltijden"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "51203",
								"display": "3 maaltijden"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51300",
					"text": "Geselecteerde consumptie indicatoren voor eiwit inname",
					"type": "group",
					"item": [
						{
							"linkId": "51400",
							"text": "Tenminste eenmaal dagelijks melkproducten",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"answerOption": [
								{
									"valueCoding": {
										"code": "51401",
										"display": "Ja"
									}
								},
								{
									"valueCoding": {
										"code": "51402",
										"display": "Nee"
									}
								}
							],
							"required": true
						},
						{
							"linkId": "51500",
							"text": "Melk, kaas, yoghurt of pudding twee of meer porties per week",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"answerOption": [
								{
									"valueCoding": {
										"code": "51501",
										"display": "Ja"
									}
								},
								{
									"valueCoding": {
										"code": "51502",
										"display": "Nee"
									}
								}
							],
							"required": true
						},
						{
							"linkId": "51600",
							"text": "Dagelijks vlees, vis of gevogelte",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"answerOption": [
								{
									"valueCoding": {
										"code": "51601",
										"display": "Ja"
									}
								},
								{
									"valueCoding": {
										"code": "51602",
										"display": "Nee"
									}
								}
							],
							"required": true
						}
					]
				},
				{
					"linkId": "51700",
					"text": "Gebruikt 2 of meer porties fruit of groenten per dag?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51702",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "51701",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51800",
					"text": "Hoeveel vloeistof wordt er dagelijks genuttigd?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "51801",
								"display": "Minder dan 3 glazen/koppen"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0.5
								}
							],
							"valueCoding": {
								"code": "51802",
								"display": "3 tot 5 glazen/koppen"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "51803",
								"display": "Meer dan 5 glazen/koppen"
							}
						}
					],
					"required": true
				},
				{
					"linkId": "51900",
					"text": "Manier van voeden",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51901",
								"display": "Niet in staat zelfstandig te eten"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51902",
								"display": "Gebruikt de maaltijd met enige moeite"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "51903",
								"display": "Gebruikt de maaltijd zelfstandig"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "52000",
					"text": "Oordeel van de patiënt zelf met betrekking tot zijn voedingskundige status",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "52001",
								"display": "Beoordeelt zichzelf als ondervoed"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "52002",
								"display": "Is onzeker ten aanzien van de voedingskundige status"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "52003",
								"display": "Beoordeelt zichzelf als zijnde zonder voedingskundige problemen"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "52100",
					"text": "Hoe beschouwt de patiënt zijn/haar gezondheidstoestand in vergelijking met leeftijdsgenoten?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "52101",
								"display": "Minder goed"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0.5
								}
							],
							"valueCoding": {
								"code": "52102",
								"display": "Weet het niet"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "52103",
								"display": "Even goed"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							],
							"valueCoding": {
								"code": "52104",
								"display": "Beter"
							}
						}
					],
					"required": true
				},
				{
					"linkId": "52200",
					"text": "Middenarm omtrek (MAC) in cm",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "52201",
								"display": "MAC minder dan 21"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0.5
								}
							],
							"valueCoding": {
								"code": "52202",
								"display": "MAC tussen 21 en 22"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "52203",
								"display": "MAC 22 of meer"
							}
						}
					],
					"required": true
				},
				{
					"linkId": "52300",
					"text": "Omtrek van de kuit (CC) in cm",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "52301",
								"display": "CC minder dan 31"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "52302",
								"display": "CC 31 of meer"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					],
					"required": true
				}
			]
		}
	]
}
